export const maxStringLength = {
  username: 50,
  email: 254,
  password: 128,
  koumutenName: 50,
  companyName: 50,
  modelName: 50,
  labelName: 50,
  projectName: 50,
  imageName: 50
} as const;
